import $ from 'jquery';

const logout = () => {
    $.ajax({
      url: "/oauth/logout",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        localStorage.clear(); //Clear localStorage

        //Clear Cookies
        var allCookies = document.cookie.split(';');
        for (var i = 0; i < allCookies.length; i++)
          document.cookie = allCookies[i] + "=;expires="
            + new Date(0).toUTCString();
        window.location.href = "/sales-desk/login";
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  export default logout;


// WEBPACK FOOTER //
// ./src/sales-desk/login/Logout.js